import {useRequestHeaders, useRuntimeConfig} from '#imports';

const mobileUserAgentPattern = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

export const getServerBreakpointFlags = (userAgent: string | undefined): {isWide: boolean; isTablet: boolean; isMobile: boolean} => {
    const isMobileClient = !!userAgent && mobileUserAgentPattern.test(userAgent);
    return {
        isWide: false,
        isTablet: isMobileClient,
        isMobile: isMobileClient,
    };
};

export const useBreakpointsHelper = (): {isWide: boolean; isTablet: boolean; isMobile: boolean} => {
    const {breakpoints} = useRuntimeConfig().public;

    if (import.meta.server) {
        const {'user-agent': userAgent} = useRequestHeaders(['user-agent']);
        return getServerBreakpointFlags(userAgent);
    } else {
        const isMobileWindow = window.innerWidth <= breakpoints.mobile;
        const isTabletWindow = window.innerWidth <= breakpoints.tablet;
        const isWideWindow = window.innerWidth > breakpoints.wide;
        return {
            isWide: isWideWindow,
            isTablet: isTabletWindow,
            isMobile: isMobileWindow,
        };
    }
};
